import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { hot } from "react-hot-loader";
import classNames from "classnames";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import * as firebaseui from "firebaseui";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import firebase from "../../config/firebase";
import logo from "../../assets/img/_logo.png";
import bg from "../../assets/img/cubes.png";
import { withSnackbar } from "notistack";

const uiConfig = (props) => ({
  callbacks: {
    signInSuccessWithAuthResult: (authResult) => {
      // console.log(authResult);
      const {
        user: { uid, displayName, email },
      } = authResult;
      try {
        // const ref = firebase.db.collection('users').doc(uid);
        // console.log({ ref });
        // const user = await ref.get();
        // console.log(user);
        // if (!user.data()) {
        //   ref.set({
        //     _sys: { createDate: Date.now() },
        //     uid,
        //     email,
        //     displayName
        //   });
        // }
      } catch (e) {
        console.info("Failed to create user entry", e);
      }
      // debugger;
      return false;
    },
    signInFailure: (error) => {
      this.props.enqueueSnackbar("Error logging in...", {
        variant: "error",
      });
    },
  },
  credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
  signInFlow: "popup",
  signInSuccessUrl: "/edit",
  signInOptions: [
    firebase.authObj.GoogleAuthProvider.PROVIDER_ID,
    // firebase.authObj.GithubAuthProvider.PROVIDER_ID,
    // firebase.authObj.FacebookAuthProvider.PROVIDER_ID,
    // firebase.authObj.TwitterAuthProvider.PROVIDER_ID
    // firebase.authObj.EmailAuthProvider.PROVIDER_ID
    // firebase.authObj.PhoneAuthProvider.PROVIDER_ID
  ],
  tosUrl: "/term-and-conditions",
});

const styles = (theme) => ({
  bgHolder: {
    backgroundColor: `#000`,
    // background: `url('https://www.transparenttextures.com/patterns/maze-black.png') repeat`,
    // background: `url('https://www.transparenttextures.com/patterns/inspiration-geometry.png') repeat`,
    background: `url('https://www.transparenttextures.com/patterns/dark-fish-skin.png') repeat`,
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
  },

  root: {
    position: "relative",
    display: "flex",
    flexGrow: 1,
    margin: theme.spacing(5),
    justifyContent: "center",
    zIndex: 1,
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      margin: theme.spacing(),
    },
  },

  logo: {
    opacity: 0.9,
    display: "flex",
    background: "#000",
    "& img": {
      width: 205,
      margin: `${theme.spacing(3)}px auto`,
    },
  },

  panelHolder: {
    border: "1px solid #111",
    boxShadow: "rgba(0,0,0,1) 0px 0px 4px 0px",
  },

  panel: {
    position: "relative",
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    boxSizing: "border-box",
    background: "#fff",
  },

  progressBar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
  },

  loginPanelContent: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(4),
  },
});

class Login extends Component {
  render() {
    // Always redirect to dashboard if user is authenticated
    if (firebase.auth.currentUser) {
      return <Redirect to="/" />;
    }

    const { classes } = this.props;

    return (
      <div className={classes.bgHolder}>
        <Grid container className={classes.root}>
          <Grid item xs={12} sm={6} lg={4} xl={3}>
            <div className={classes.panelHolder}>
              <div className={classes.logo}>
                <img src={logo} />
              </div>
              <div className={classNames(classes.panel, classes.loginPanel)}>
                {this.props.loading && (
                  <LinearProgress className={classes.progressBar} />
                )}
                <div className={classes.loginPanelContent}>
                  <div className={classes.container}>
                    <StyledFirebaseAuth
                      uiConfig={uiConfig(this.props)}
                      firebaseAuth={firebase.auth}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default connect(
  ({ appState }) => ({
    loading: appState.loading,
  }),
  {}
)(hot(module)(withStyles(styles)(withSnackbar(Login))));
